"use strict";

module.exports = function () {
  if (typeof ga === "undefined") {
    return false;
  }
  return true;
};
